import { render, staticRenderFns } from "./ImportCandidates.vue?vue&type=template&id=3b4295cd&"
import script from "./ImportCandidates.vue?vue&type=script&lang=js&"
export * from "./ImportCandidates.vue?vue&type=script&lang=js&"
import style0 from "./ImportCandidates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports